import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  header: {
    id: 'ClosingEventForm.header',
    defaultMessage: 'Closing Page',
  },
  subheader: {
    id: 'ClosingEventForm.subheader',
    defaultMessage:
      'After a guest leaves an entry, the guest will see a closing message. This can be a thank you or whatever you like.',
  },
  headerLabel: {
    id: 'ClosingEventForm.headerLabel',
    defaultMessage: 'Header text i.e. "Thank you"',
  },
  headerName: {
    id: 'ClosingEventForm.headerName',
    defaultMessage: 'Header',
  },
  messageLabel: {
    id: 'ClosingEventForm.messageLabel',
    defaultMessage:
      'Write a message for your guests to see after leaving a message. This is optional.',
  },
  messageName: {
    id: 'ClosingEventForm.messageName',
    defaultMessage: 'Message',
  },
  errorLabel: {
    id: 'ClosingEventForm.errorLabel',
    defaultMessage: '{field} is required',
  },
  submitButton: {
    id: 'ClosingEventForm.submitButton',
    defaultMessage: 'Submit',
  },
})
